module.exports = __webpack_public_path__ + "static/between-meals-28d956314d373514695ca3c92ef189b2.jpg";